import { render, staticRenderFns } from "./uploadFileForPC.vue?vue&type=template&id=0963f0da&scoped=true"
import script from "./uploadFileForPC.vue?vue&type=script&lang=js"
export * from "./uploadFileForPC.vue?vue&type=script&lang=js"
import style0 from "./uploadFileForPC.vue?vue&type=style&index=0&id=0963f0da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963f0da",
  null
  
)

export default component.exports